import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.recreativa.com.br/api/',
});

export default api;
